<template>
    <div class="enrollmentRegulations w-100">
        <div class="top padding w-100">
            <div v-show="zsZcDirectory.length>0&&!zsZcMlLoading">
                <div v-for="item in zsZcDirectory" :key="item.id" :class="item.id===zsJzId?'directoryActive':''">
                    {{item.title}}
                </div>
            </div>
            <empty v-show="zsZcDirectory.length<1&&!zsZcMlLoading" content="暂无相关章程目录" :text-size="18" :widths="150" :heights="150">
            </empty>
            <loading v-show="zsZcMlLoading" width="1025px"></loading>
        </div>
        <div class="content   w-100">
            <div>
                <h5>{{zsZcContent.title}}</h5>
                <div  v-html="zsZcContent.enrollRule">

                </div>
            </div>
            <empty v-show="zsZcContent===''&&!zsZcContentLoading" content="暂无相关章程详情" :text-size="18" :widths="150" :heights="150">
            </empty>
            <loading v-show="zsZcContentLoading" width="1025px"></loading>
        </div>
    </div>
</template>

<script>
    import {uniZsJz, uniZsJzDetail} from "../../../../../config";
    import {EventBus} from "../../../../../assets/static/global/event-bus";

    export default {
        name: "enrollmentRegulations",
        props:{
            univerSityId:String
        },
        data(){
            return{
                zsZcMlLoading:false,
                zsZcDirectory:[],
                zsZcContent:'',
                zsZcContentLoading:false,
                //获取所选择的招生简章id
                zsJzId:''
            }
        },
        mounted() {
            EventBus.$on('collegeZsjz',()=>{
                this.getUniZsJz();
            })
        },
        methods:{
            //查出南京大学招生章程
            async getUniZsJz(){
                this.zsZcMlLoading=true;
                let result=await uniZsJz(this.univerSityId);
                if(result.status){
                    this.zsZcMlLoading=false;
                    this.zsZcDirectory=result.data;
                    this.zsJzId=result.data[0].id;
                    this.getUniZsJzDetail();
                }else{
                    this.zsZcMlLoading=true;
                }
            },
            selectZsJz(val){
                this.zsJzId=val;
                this.getUniZsJzDetail();
            },
            //查出招生简章详情
            async getUniZsJzDetail(){
                this.zsZcContentLoading=true;
                let result=await uniZsJzDetail(this.zsJzId);
                if(result.status){
                    this.zsZcContentLoading=false;
                    this.zsZcContent=result.data;
                }else{
                    this.zsZcContentLoading=false;
                }
            }
        }
    }
</script>
<style lang="scss">
    .enrollmentRegulations{
        p{
            color: #666666!important;
            line-height: 30px!important;
        }
    }
</style>
<style lang="scss" scoped>
    .enrollmentRegulations{

        .top{

            div{
                >div{
                    padding: 0 14px;
                    margin-bottom: 10px;
                    line-height: 34px;
                    cursor: pointer;
                    background-color: #f3f3f3;
                }
            }
        }
        .content{
            min-height: 200px;
            padding: 0 10px 30px;

            font-size: 16px;
            h5{
                padding: 0 10px 30px;
                text-align: center;
                font-size: 16px;
                font-weight: bold;
            }


        }

    }
</style>